import { render, staticRenderFns } from "./CompanyBasicForm.vue?vue&type=template&id=f67340f4&scoped=true&"
import script from "./CompanyBasicForm.vue?vue&type=script&lang=js&"
export * from "./CompanyBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67340f4",
  null
  
)

export default component.exports